import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { XFieldComponent } from '../x-field/x-field.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'x-textarea',
  templateUrl: 'x-textarea.component.html',
  styleUrls: ['./x-textarea.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => XTextareaComponent), multi: true }
  ]
})
export class XTextareaComponent extends XFieldComponent {

  constructor(
    protected matSnackBar: MatSnackBar
  ) {
    super(matSnackBar);
  }

}
